// src/pages/CheckInPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CTAButton from "../components/common/CTAButton";
import { fetchQuestions, submitCheckIn } from "../services/checkInApi";
import "./CheckInPage.css";

const CheckInPage = () => {
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadQuestions = async () => {
      try {
        const data = await fetchQuestions();
        setQuestions(data);
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load check-in questions.");
      } finally {
        setLoading(false);
      }
    };

    loadQuestions();
  }, []);

  const handleChange = (questionCode, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionCode]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");

    try {
      const result = await submitCheckIn(answers);
      navigate("/check-in/result", { state: { assessment: result } });
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to submit check-in.");
    } finally {
      setSubmitting(false);
    }
  };

  const renderField = (question) => {
    if (question.input_type === "select") {
      return (
        <div className="checkin-page__option-group">
          {question.options?.map((opt) => (
            <label key={opt.option_value} className="checkin-page__option">
              <input
                type="radio"
                name={question.question_code}
                value={opt.option_value}
                checked={answers[question.question_code] === opt.option_value}
                onChange={(e) =>
                  handleChange(question.question_code, e.target.value)
                }
                required
              />
              <span>{opt.option_label}</span>
            </label>
          ))}
        </div>
      );
    }

    if (question.input_type === "number") {
      return (
        <>
          <input
            className="checkin-page__input"
            type="number"
            min="0"
            value={answers[question.question_code] || ""}
            onChange={(e) =>
              handleChange(question.question_code, e.target.value)
            }
            required
          />
         
        </>
      );
    }

    return null;
  };

  if (loading) {
    return (
      <main className="checkin-page" aria-label="Relapse risk check-in">
        <div className="checkin-page__container">
          <p className="checkin-page__status">Loading check-in questions...</p>
        </div>
      </main>
    );
  }

  return (
    <main className="checkin-page" aria-label="Relapse risk check-in">
      <div className="checkin-page__container">
        <header className="checkin-page__header">
          <div className="checkin-page__icon" aria-hidden="true">
            🩺
          </div>
          <h1 className="checkin-page__heading">Smoking Risk Check-In</h1>
          <p className="checkin-page__message">
            Answer a few questions to see your current relapse risk, what is
            driving it, and practical steps you can take.
          </p>
        </header>

        <form className="checkin-page__form" onSubmit={handleSubmit}>
          {questions.map((q) => (
            <section key={q.question_id} className="checkin-page__field">
              <label className="checkin-page__label">{q.question_text}</label>
              {renderField(q)}
            </section>
          ))}

          {error && <p className="checkin-page__error">{error}</p>}

          <div className="checkin-page__actions">
            <CTAButton
              type="submit"
              label={submitting ? "Submitting..." : "Submit check-in"}
              disabled={submitting}
            />

            <CTAButton
              label="Back to Home"
              to="/"
              ariaLabel="Return to home"
            />
          </div>
        </form>
      </div>
    </main>
  );
};

export default CheckInPage;
